import { ResponseOptions, ResponseSuccess, withCors } from '@websolutespa/payload-utils/server';
import { addDataAndFileToRequest, PayloadHandler, PayloadRequest } from 'payload';
import { appHandler } from './app.handler';
import { errorHandler } from './error.handler';
import { threadHandler } from './thread.handler';
import { LlmInfo } from './types';

export const infoHandler: PayloadHandler = async (req: PayloadRequest) => {
  if (req.method === 'OPTIONS') {
    return ResponseOptions();
  }
  const headers = withCors({ req, cors: '*' });
  try {
    await addDataAndFileToRequest(req);
    const app = await appHandler(req);

    const info: LlmInfo = {
      contents: app.contents,
    };
    const { threadId } = req.body as { threadId?: string };
    if (app && threadId) {
      const thread = await threadHandler(req, app.id);
      info.thread = {
        messages: thread.message.map((x) => ({ ...x })),
        threadId,
      };
    }
    return ResponseSuccess(info, { headers });
  } catch (error) {
    return errorHandler(error, { headers });
  }
};
